export interface Preferences {
  catering: CateringPreferences;
  groundTransportations: GroundTransportationPreference[];
  hotels: HotelPreference[];
  airlines: AirlinePreference[];
}

export interface CateringPreferences {
  preferenceIds: { [key: string]: number } | null;
  beverages: string | null;
  snacks: string | null;

  breakfast: string | null;
  lunch: string | null;
  dinner: string | null;

  dietaryPreferences: string | null;
  allergies: string | null;
}

export interface GroundTransportationPreference {
  readonly groundTransportationId: number | null;
  provider: string | null;
  loyaltyNumber: string | null;
  isPrimary: boolean;
}

export interface HotelPreference {
  readonly hotelId: number | null;
  hotelName: string | null;
  loyaltyNumber: string | null;
  isPrimary: boolean;
}

export interface AirlinePreference {
  readonly airlineId: number | null;
  airlineName: string | null;
  frequentFlyerNumber: string | null;
  isPrimary: boolean;
}

export const isGroundTransportationPreferenceSaved = (
  groundTransportation: GroundTransportationPreference
) => {
  return (
    groundTransportation.groundTransportationId && groundTransportation.groundTransportationId > 0
  );
};

export const isHotelPreferenceSaved = (hotelPref: HotelPreference) => {
  return hotelPref.hotelId && hotelPref.hotelId > 0;
};

export const isAirlinePreferenceSaved = (airlinePref: AirlinePreference) => {
  return airlinePref.airlineId && airlinePref.airlineId > 0;
};

export const isCateringPreferencesSaved = (cateringPrefs: CateringPreferences) => {
  return !cateringPrefs.preferenceIds;
};
